import { IDeleteObraAlvenariaEstruturalUseCase } from "../../../presentation/useCases/delete/delete_obra_alvenaria_estrutural_use_case";
import { IObrasRepository } from "../../repositories/obras_repository";

// DeleteObraAlvenariaEstruturalUseCase
 
export class DeleteObraAlvenariaEstruturalUseCase implements IDeleteObraAlvenariaEstruturalUseCase {
  constructor(private readonly repository: IObrasRepository) { }
  async deleteObraAlvenariaEstrutural(
    IdAlvenariaObra: number,
    IdObra: number,
  ): Promise<void> {
    await this.repository.deleteObraAlvenariaEstrutural(IdAlvenariaObra, IdObra);
  }
}
